import React from 'react';
import './BackButton.css';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";

export default function BackButton({label, to = '/'}) {
    const navigate = useNavigate();
    const {t} = useTranslation();

    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="page-title-box">
                    <h4 className="page-title">
                        <a
                            className="back-link"
                            href={to}
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(to);
                            }}
                        >
                            <FontAwesomeIcon icon={faChevronLeft}/>
                            <span>{label || t("Dashboard")}</span>
                        </a>
                    </h4>
                </div>
            </div>
        </div>
    );
}
